:host {
  display: contents;

  ::slotted(ld-table-row) {
    --ld-table-selection-wrapper-border-width-top: calc(var(--ld-sp-1) * 0.5);
    --ld-table-selection-wrapper-border-width-bottom: var(--ld-sp-1);
  }
}

thead {
  background-image: var(--ld-table-head-gradient);
  position: sticky;
  top: 0;
  z-index: 2;
}
